<script setup>
    import { reactive } from 'vue'
    import { useRouter } from 'vue-router'
    import Cognito  from '../utils/cognito.js'

    const router = useRouter()
    //ログイン処理に必要な値のリアクティブオブジェクト
    const loginState = reactive({
        // エラーメッセージ
        errorMessage: '',
        // 入力欄
        inputValueId: "",
        inputValuePassword: "",
    })
    // ログインボタンの活性/非活性
    let isDisabled = false

    // ログイン
    const logIn = async() => {
        // IDとパスワードの未入力チェック
        if(!loginState.inputValueId || !loginState.inputValuePassword) {
            loginState.errorMessage = 'IDまたはパスワードが未入力です'
            return
        }
        // エラーメッセージの消去
        loginState.errorMessage = ""
        // id,passを取得
        const inputEmail = loginState.inputValueId
        const inputPassword = loginState.inputValuePassword
        // 連続クリックを防ぐためにログインボタンを非活性にする
        isDisabled = true
        // 認証を実行
        try{
            await Cognito.loginCognitoUser(inputEmail, inputPassword);
            // 成功したらダッシュボード画面へ
            router.replace('/')
        } catch (err) {
            alert(err)
            // ログインボタンを再度活性
            isDisabled = false
        }
    }
    
</script>
<template>
    <header>
        <div class="title">ProoFaceAPI 管理画面</div>
    </header>

    <main>
        <div class="loginArea">
            <div class="inputContainer">
                <p>管理者メールアドレス</p>
                <input type="email" v-model="loginState.inputValueId">
            </div>

            <div class="inputContainer">
                <p>管理者パスワード</p>
                <input type="password" v-model="loginState.inputValuePassword">
            </div>

            <div class="errorMessage">
                <p>{{ loginState.errorMessage }}&nbsp;</p>
            </div>

            <div>
                <button class="nextButton" :disabled="isDisabled" type="button" @click="logIn">ログイン</button>
            </div>
            <div id="passwordresetlink">
                <router-link :to="{name: 'passwordreset'}">パスワードを忘れた方はこちら</router-link>
            </div>
            <div id="licenseslink">
                <router-link :to="{name: 'licenses'}">オープンソースライセンス</router-link>
            </div>
        </div>
    </main>
</template>

<style scoped>
    header {
        height: 120px;
    }
    header .title {
        text-align: center;
        font-size: 40px;
        padding: 20px 0 0;
    }
    main {
        padding: 30px 0;
    }
    .inputContainer {
        position: relative;
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .inputContainer input {
        width: 400px;
    }
    .inputContainer p {
        width: 200px;
        margin: 30px 0 30px 0;
    }
    .errorMessage p {
        color: red;
    }
    #passwordresetlink{
        margin: 20px 0;
    }
    #licenseslink{
        margin: 0 0 20px 0;
    }
    @media (max-width: 1150px) {
        .inputContainer input {
            width: 300px;
        }
    }

</style>